import React, { Suspense } from 'react';
import { CircularProgress } from '../Common';

const Home = React.lazy(() => import('./Home'));

// Show a spinner while the profile is loading
export default function Root(): JSX.Element {
  return (
    <Suspense fallback={<CircularProgress />}>
      <Home />
    </Suspense>
  );
}
